module.exports = __webpack_public_path__ + "img/brain-word-logo.1155679c.svg";